import React, { useRef } from 'react';
import { useNavigateAndScroll } from '../../Hooks/useNavigateAndScroll';

const RefillRequests = () => {
  const barRef = useRef(null);
  const navigateAndScroll = useNavigateAndScroll();
  const infoCardsData = {
    newPatient: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/New+Pt+registration.webp',
      infoTitle: 'New Patient Registration',
      infoText: 'Quickly register online for your first visit. Fill out personal, insurance, and health history details to get started with our practice in just a few minutes.',
      path: '/patient-center/new-patient'
    },
    patientForms: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Patient+forms.webp',
      infoTitle: 'Patient Forms',
      infoText: 'Access all necessary intake and consent forms to streamline your visit. Download, complete, and upload them securely before your appointment.',
      path: '/patient-center/patient-forms'
    },
    refillRequests: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Med+refill.webp',
      infoTitle: 'Refill Requests',
      infoText: 'Submit medication refill requests online anytime. Our team will process them promptly and notify you when they’re ready for pickup or sent to your pharmacy.',
      path: '/patient-center/refill-requests'
    },
    officePolicies: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Office+Policy.webp',
      infoTitle: 'Office Policies',
      infoText: 'Review our appointment, cancellation, and billing policies to ensure a smooth experience. Everything you need to know about visits, payments, and patient responsibilities.',
      path: '/patient-center/office-policies'
    },
    faqs: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/FAQ.webp',
      infoTitle: "FAQ's",
      infoText: 'Find quick answers to the most common questions—hours of operation, new patient procedures, after-hours care, and more—all in one place.',
      path: '/patient-center/faqs'
    }
  };
  return (
    <div>
    <div className="relative w-auto z-1 mt-[-70px]">
          <img
            className="w-full h-auto rounded-lg shadow-lg mt-2"
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Med+refill+submenu_InPixio.webp"
            alt="Mother and child meeting a doctor"
          />
        </div>
    <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50">
        {Object.values(infoCardsData).map((card) => (
          <button
            key={card.infoTitle}
            className="p-1 text-sm cursor-pointer grow-text"
            onClick={() => navigateAndScroll(card.path, card.infoTitle)}
          >
            {card.infoTitle}
          </button>
        ))}
      </div>
    <div className="w-full px-4 py-8 sm:px-6 lg:px-64">
      {/* Title */}
      <h2 className="text-4xl font-bold text-gray-800 mb-2">Refill Requests</h2>
      <hr className="border-t-2 border-blue-500 mb-6" />

      <div className="space-y-6">
        {/* Intro / General Info */}
        <section>
          <p className="mb-4 text-gray-600">
            We recommend that you contact your pharmacy directly to request a medication refill. Once received, we will authorize the refill electronically to the pharmacy.
          </p>
          <p className="mb-4 text-gray-600">
            The guidelines for refills for various conditions are as follows:
          </p>
        </section>

        {/* Numbered List of Guidelines */}
        <section>
          <ol className="list-decimal list-outside ml-6 space-y-4 text-gray-600">
            {/* 1. Stable ADHD/ADD */}
            <li>
              <h3 className="font-bold text-gray-800 mb-1">Stable ADHD/ADD</h3>
              <p>
                We will authorize a prescription for a three-month supply. We recommend rechecks every three months, with Vanderbilt follow-up forms completed by both parents and teachers every six months.
              </p>
            </li>

            {/* 2. Asthma */}
            <li>
              <h3 className="font-bold text-gray-800 mb-1">Asthma Medication Refills</h3>
              <p>
                For frequent users of rescue inhalers (e.g., albuterol) or regular users of controller medications (e.g., steroids), we recommend an in-office asthma recheck. Patients should bring all medications to the visit. We may also do a lung function test during this visit.
              </p>
            </li>

            {/* 3. Allergic Rhinitis */}
            <li>
              <h3 className="font-bold text-gray-800 mb-1">
                Allergic Rhinitis Medication Refills
              </h3>
              <p>
                We recommend that patients using nasal steroid sprays frequently be seen in the office at least every three months.
              </p>
            </li>

            {/* 4. Eczema */}
            <li>
              <h3 className="font-bold text-gray-800 mb-1">Eczema Medication Refills</h3>
              <p>
                Medium- or high-potency steroid creams will only be refilled following an in-office recheck.
              </p>
            </li>

            {/* 5. Antidepressant/Anti-Anxiety */}
            <li>
              <h3 className="font-bold text-gray-800 mb-1">
                Antidepressant/Anti-Anxiety Medication Refills
              </h3>
              <p>
                For patients on these medications, we recommend a check-in office every month to assess progress and medication effectiveness.
              </p>
            </li>
          </ol>
        </section>

        {/* Closing Note */}
        <section>
          <p className="mb-4 text-gray-600">
            Please contact us for further assistance or clarification.
          </p>
        </section>
      </div>
    </div>
    </div>
  );
};

export default RefillRequests;
